/*
 * Copyright (c) 2021 Omnicell. All rights reserved.
 *
 * This program contains proprietary, trade secret information of
 * Omnicell. and may not be copied, reproduced or reverse engineered
 * in any way without the prior written permission of Omnicell.
 */

import { AdaptiveCard } from 'adaptivecards-react';
import React, { useEffect, useRef } from 'react';
import { handleAdaptiveCardA11y } from '../utils/a11y-helpers';

// React component that wraps an AdaptiveCards card component. Handles card events.
const Card = ({ body, handleCardActionSubmit, handleCardActionOpenUrl }) => {
  const cardRef = useRef(null);

  // Navigation-only cards (Back/Start Over) must not steal focus from sibling form cards.
  // Detected from the body schema: no Input.* elements and contains the known nav action IDs.
  const bodyStr = JSON.stringify(body);
  const isNavCard =
    !bodyStr.includes('"Input.') &&
    bodyStr.includes('"id":"back"') &&
    bodyStr.includes('"id":"start_over"');

  useEffect(() => {
    // Wait for Adaptive Cards library to render the actual card DOM
    if (cardRef.current) {
      const cardElement = cardRef.current.querySelector('.ac-adaptiveCard');
      if (cardElement) {
        handleAdaptiveCardA11y(cardElement, isNavCard);
      } else {
        // If card not rendered yet, wait for it
        const observer = new MutationObserver(() => {
          const card = cardRef.current?.querySelector('.ac-adaptiveCard');
          if (card) {
            observer.disconnect();
            handleAdaptiveCardA11y(card, isNavCard);
          }
        });

        observer.observe(cardRef.current, {
          childList: true,
          subtree: true
        });

        return () => observer.disconnect();
      }
    }
  }, [body]);

  return (
    <div ref={cardRef}>
      <AdaptiveCard
        payload={body}
        onActionSubmit={handleCardActionSubmit}
        // ON ACTION OPEN URL WE NEEED
        // TO MAKE REQUEST TO THE SERVER WITH ACTION ID
        onActionOpenUrl={handleCardActionOpenUrl}
      />
    </div>
  );
};

export default React.memo(Card);
